// @flow

import * as React from 'react';
import type {SvgProps} from 'react-native-svg';

export type Icon = React.Component<SvgProps>;
